import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { usePrices } from './usePrices'
import { useMemo } from 'react'

export const useMinimums = () => {
  const cubeCtx = useCubeContext()
  const { prices } = usePrices()
  const phases = cubeCtx.queries.orderedPhases

  const minimums = useMemo(() => {
    return phases
      .filter(phase => phase.minimums[0])
      .map(phase => {
        const minimum = phase.minimums[0]
        return {
          ...minimum,
          phaseId: phase.id,
          productIds: minimum.scope.priceIds
            .map(
              priceId => prices.find(price => price.id === priceId)?.productId
            )
            .filter(Boolean) as string[]
        }
      })
  }, [phases, prices])

  return {
    minimums
  }
}
